module.exports = __webpack_public_path__ + "static/img/stripe.9e041fb1.png";